import { SectionBox } from '@shared/components/ui/SectionBox';
import { Skeleton } from '@shared/components/ui/shadcn/skeleton';

export const IntegratedMessagingSkeleton = () => {
  return (
    <div className="w-full pb-6" data-testid="integrated-messaging-skeleton">
      <div className="flex justify-between gap-4">
        <div className="min-w-0 space-y-2">
          <Skeleton className="h-8 w-56 rounded-full bg-hover-press" />
          <Skeleton className="h-4 w-72 max-w-full rounded-full bg-hover-press" />
        </div>
        <div className="flex shrink-0 items-center">
          <Skeleton className="h-10 w-32 rounded-full bg-hover-press" />
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-4">
        {[1, 2, 3, 4].map((index) => (
          <SectionBox key={index}>
            <div className="flex h-full flex-col justify-between">
              <div className="mb-4 flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <Skeleton className="h-10 w-10 rounded-full bg-hover-press" />
                  <Skeleton className="h-6 w-32 rounded-full bg-hover-press" />
                </div>
                <Skeleton className="h-8 w-8 rounded-md bg-hover-press" />
              </div>
              <Skeleton className="h-6 w-20 rounded-full bg-hover-press" />
            </div>
          </SectionBox>
        ))}
      </div>
    </div>
  );
};
